import { render, staticRenderFns } from "./lecturerList.vue?vue&type=template&id=51ab6c5f&scoped=true"
import script from "./lecturerList.vue?vue&type=script&lang=js"
export * from "./lecturerList.vue?vue&type=script&lang=js"
import style0 from "./lecturerList.vue?vue&type=style&index=0&id=51ab6c5f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ab6c5f",
  null
  
)

export default component.exports